<ng-container *ngIf="permConfig.isViewAllowed">
  <div class="container-fluid">
    <app-page-title title="List Air Waybills"></app-page-title>
    <div class="card card-body">
        <div class="row" [formGroup]="filterForm" *ngIf="!isCustomerLogin">
          <div class="d-flex flex-wrap">
            <button type="button" ngbTooltip="Scan" placement="bottom" container="body" class="btn btn-outline-secondary position-relative p-0 avatar-xs" title="Scan">
                <span (click)="scanAWB()" class="avatar-title bg-transparent text-reset">
                    <i class="fa fa-barcode"></i>
                </span>
            </button>
            <button type="button" ngbTooltip="Track" placement="bottom" container="body" class="btn btn-outline-secondary position-relative p-0 avatar-xs" title="Track">
              <span (click)="tracking()" class="avatar-title bg-transparent text-reset">
                  <i class="mdi mdi-map-marker-radius"></i>
              </span>
            </button>
            <div ngbDropdown container="body" [autoClose]="'outside'" #dropdown="ngbDropdown">
              <button ngbDropdownToggle type="button" class="btn btn-outline-secondary btn-sm" style="height: 2rem;margin-left: 10px;">
                <i class="mdi mdi-filter-outline me-1"></i>Filters
                <span [ngClass]="dropdown.isOpen() ? 'mdi mdi-chevron-up label-icon ms-1' : 'mdi mdi-chevron-down label-icon ms-1'"></span>
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownConfig" class="dropdown-menu dropdown-menu-end">
                <div class="dropdown-item">
                  <input class="form-check-input" type="checkbox" id="generatedbyme" formControlName="generatedByMeCheck" (change)="canApply('generatedByMeCheck')">
                  <label for="generatedbyme" class="form-label ms-2">Generated By Me</label>
                </div>
                <div class="dropdown-item">
                  <input class="form-check-input" type="checkbox" id="addCommentsCheckbox" formControlName="receivedCheck" (change)="canApply('receivedCheck')" />
                  <label class="form-label ms-2" for="addCommentsCheckbox">Received Shipments</label>
                </div>
                <div class="dropdown-item">
                  <input class="form-check-input" type="checkbox" id="updateStatusCheckbox" formControlName="customerGeneratedCheck" (change)="canApply('customerGeneratedCheck')" />
                  <label class="form-label ms-2" for="updateStatusCheckbox">Customer Generated</label>
                </div>
                <div class="dropdown-divider"></div>
                <div class="dropdown-header row mt-1 col-md-12" style="display: flex; justify-content: space-evenly;">
                  <button type="button" class="btn btn-primary btn-sm" [disabled]="isFilterApplyDisable" style="width: 40%;" (click)="dropdown.close();filterAWB()">Apply</button>
                  <button type="button" class="btn btn-outline-secondary btn-sm" style="width: 40%;" (click)="dropdown.close();canApply('generatedByMeCheck');filterAWB();">Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-grow-1 d-flex justify-content-end align-items-center">
          <a routerLink="add"><button type="button" class="btn btn-success btn-sm"><i class="mdi mdi-plus me-1"></i>Add
              AWB</button></a>
        </div>
      </div>

    <div class="card card-body">
      <!-- <form [formGroup]="filterForm" class="d-flex mb-2" *ngIf="!isCustomerLogin"> -->
        <!-- <div class="filter-group" *ngIf="!isAccessTypeCustomer">
          <span><b>Show</b></span>
          <div class="filter-chip ms-4">
            <input id="received" class="form-check-input me-2 pointer" type="checkbox" formControlName="receivedCheck"
              (change)="filterAWB()" />
            <label for="received" class="form-label pointer">Received Shipments</label>
          </div>

          <div class="filter-chip ms-4">
            <input id="customergenerated" class="form-check-input me-2 pointer" type="checkbox"
              formControlName="customerGeneratedCheck" (change)="filterAWB()" />
            <label for="customergenerated" class="form-label pointer">Customer Generated</label>
          </div>
        </div> -->
        
        <!-- <div _ngcontent-qxt-c76="" class="row mt-1">
          <div class="col-md-12" style="
          justify-content: space-evenly;
          display: flex;
      ">
          <button _ngcontent-qxt-c76="" type="button" class="btn btn-primary btn-sm" style="
          width: 40%;
      " disabled="">Apply</button><button _ngcontent-qxt-c76="" type="button" class="btn btn-outline-primary btn-sm" style="
          width: 40%;
      ">Clear</button></div></div> -->
      <!-- </form> -->
      <div class="col-md-12 grid-container mb-2">
        <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
          [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
          [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
          [enableCellTextSelection]="true" (filterChanged)="onFilterChanged()" [pagination]="true" (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>
    </div>

  </div>

</ng-container>

<ng-container *ngIf="!permConfig.isViewAllowed">
  <app-forbidden></app-forbidden>
</ng-container>